import { defineComponent as _defineComponent } from 'vue'
import { ref as _ref } from 'vue';

import __MACROS_useVModel from "/vue-macros/define-models/use-vmodel";
import { watch } from 'vue';
import { AlertingHookService, AlertingHookDto } from '@/api';

interface Emit {
  (event: 'input', value: AlertingHookDto[]): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MsTeams-Tag-Selector',
  props: {
  value: null
},
  emits: ["input"],
  setup(__props, { emit }) {



const { value: selectedMsTeamWebhooks } = __MACROS_useVModel(["value", undefined, "input"]);

let loading = _ref(false);
let alertingHooks = _ref<AlertingHookDto[]>([]);
const searchString = _ref('');

const clear = () => {
  selectedMsTeamWebhooks.value = [];
  emit('input', selectedMsTeamWebhooks.value);
};

const fetchMsTeamsWebhooksTags = async () => {
  loading.value = true;
  const { data } = await AlertingHookService.getAllAlertingHooks({ type: AlertingHookDto.type.MS_TEAMS, itemsPerPage: -1 });
  alertingHooks.value = data!;
  loading.value = false;
};

watch(() => searchString.value, () => {
  fetchMsTeamsWebhooksTags();
});

return { __sfc: true,emit, selectedMsTeamWebhooks, loading, alertingHooks, searchString, clear, fetchMsTeamsWebhooksTags, _ref, __MACROS_useVModel, watch, AlertingHookService, AlertingHookDto }
}

})